export const endpoint = {
  user: 'user',
  users: 'user/search',
  role: 'role',
  userAccess: 'user/access',
  userRoleAllOptions: 'user/role/all/options',
  roleAccess: 'role/access',
  roleSearch: 'role/search'
};
